module.exports = __webpack_public_path__ + "img/model_market_card1.ee4d4bf8.png";